const ElectoralDistricts = {
    ANNAPOLIS: "01. Annapolis",
    ANTIGONISH: "02. Antigonish",
    ARGYLE: "03. Argyle",
    BEDFORD_BASIN: "04. Bedford Basin",
    BEDFORD_SOUTH: "05. Bedford South",
    CAPE_BRETON_CENTRE_WHITNEY_PIER: "06. Cape Breton Centre-Whitney Pier",
    CAPE_BRETON_EAST: "07. Cape Breton East",
    CHESTER_ST_MARGARETS: "08. Chester-St. Margaret's",
    CLARE: "09. Clare",
    CLAYTON_PARK_WEST: "10. Clayton Park West",
    COLCHESTER_MUSQUODOBOIT_VALLEY: "11. Colchester-Musquodoboit Valley",
    COLCHESTER_NORTH: "12. Colchester North",
    COLE_HARBOUR: "13. Cole Harbour",
    COLE_HARBOUR_DARTMOUTH: "14. Cole Harbour-Dartmouth",
    CUMBERLAND_NORTH: "15. Cumberland North",
    CUMBERLAND_SOUTH: "16. Cumberland South",
    DARTMOUTH_EAST: "17. Dartmouth East",
    DARTMOUTH_NORTH: "18. Dartmouth North",
    DARTMOUTH_SOUTH: "19. Dartmouth South",
    DIGBY_ANNAPOLIS: "20. Digby-Annapolis",
    EASTERN_PASSAGE: "21. Eastern Passage",
    EASTERN_SHORE: "22. Eastern Shore",
    FAIRVIEW_CLAYTON_PARK: "23. Fairview-Clayton Park",
    GLACE_BAY_DOMINION: "24. Glace Bay-Dominion",
    GUYSBOROUGH_TRACADIE: "25. Guysborourgh-Tracadie",
    HALIFAX_ARMDALE: "26. Halifax Armdale",
    HALIFAX_ATLANTIC: "27. Halifax Atlantic",
    HALIFAX_CHEBUCITO: "28. Halifax Chebucto",
    HALIFAX_CITADEL_SABLE_ISLAND: "29. Halifax Citadel-Sable Island",
    HALIFAX_NEEDHAM: "30. Halifax Needham",
    HAMMONDS_PLAINS_LUCASVILLE: "31. Hammonds Plains-Lucasville",
    HANTS_EAST: "32. Hants East",
    HANTS_WEST: "33. Hants West",
    INVERNESS: "34. Inverness",
    KINGS_NORTH: "35. Kings North",
    KINGS_SOUTH: "36. Kings South",
    KINGS_WEST: "37. Kings West",
    LUNENBURG: "38. Lunenburg",
    LUNENBURG_WEST: "39. Lunenburg West",
    NORTHSIDE_WESTMOUNT: "40. Northside Westmount",
    PICTOU_CENTRE: "41. Pictou Centre",
    PICTOU_EAST: "42. Pictou East",
    PICTOU_WEST: "43. Pictou West",
    PRESTON: "44. Preston",
    QUEENS: "45. Queens",
    RICHMOND: "46. Richmond",
    SACKVILLE_COBEQUID: "47. Sackville-Cobequid",
    SACKVILLE_UNIACKE: "48. Sackville-Uniacke",
    SHELBURNE: "49. Shelburne",
    SYDNEY_MEMBERTOU: "50. Sydney-Membertou",
    TIMBERLEA_PROSPECT: "51. Timberlea-Prospect",
    TRURO_BIBLE_HILL_MILLBROOK_SALMON_RIVER: "52. Truro-Bible Hill-Millbrook-Salmon River",
    VICTORIA_THE_LAKES: "53. Victoria-The Lakes",
    WAVERLEY_FALL_RIVER_BEAVER_BANK: "54. Waverley-Fall River-Beaver Bank",
    YARMOUTH: "55. Yarmouth"
}


export default ElectoralDistricts;